// extracted by mini-css-extract-plugin
export default {"table":"NftEditionsTableStructure_table__Os5dw"};